// extracted by mini-css-extract-plugin
module.exports = {"slo7d8":"slo7d8"};